export const ACTION_RESET = 'FETCH_GENERALPAGE_RESET';
export const ACTION_REQUEST = 'FETCH_GENERALPAGE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_GENERALPAGE_SUCCESS';
export const ACTION_ERROR = 'FETCH_GENERALPAGE_ERROR';
